import { useMemo } from 'react';
import { useUser } from 'hooks/redux/useUser';
import { useGroups } from 'hooks/redux/useGroups';

export function useGroupId(origin) {
  const { user } = useUser();
  const { groups } = useGroups();

  return useMemo(
    () =>
      origin
        ? groups.find((group) => group.name === origin)?.id
        : user.group_id,
    [origin, user, groups],
  );
}
